import React from 'react';
import {useTranslation} from "react-i18next";
import {Link} from "react-router-dom";
import helpers from "../Utils/helpers";
import routes from "../Constants/routes";
import {Checkbox} from "../Components/FormComponents/Checkbox";
import emailkrabbImg from "../Images/emailkrabb.png";
export default function AliasContainer ({}) {
    const { t } = useTranslation();
    const [checked, setChecked] = React.useState(false);
    
    const login = () => {
        window.location.href = `${helpers.getFullApiHostname()}/api/auth/login?returnPath=${routes.search}`;
    }
    
    return (<main className="container">
        <div className="row error-page align-items-center">
            <div className="error-page-content col-12 col-md-9">
                <h1>Email-alias för Spiris saknas</h1>
                <p>Åh nej! Det verkar som att du har missat att lägga till din Spiris-adress i din email.
                    För att säkerställa att dina framtida mejl skickas korrekt vill vi att du fixar detta innan du får logga in igen - men oroa dig inte, det är superenkelt! 😊
                    Du lägger till ditt alias i inställningarna för ditt email-konto <Link target="_blank" to={"https://mail.google.com/mail/u/0/#settings/accounts"}>här</Link>.
                </p>
                <div>
                    <Checkbox label={"Jag har lagt till mitt alias nu 😎"} checked={checked} onChange={() => setChecked(!checked)}></Checkbox>
                </div>
                <p className="error-page-home-link pt-24">
                    <button className="btn btn-primary btn-sm no-margin" onClick={login} disabled={!checked}>{"Logga in igen"}</button>
                </p>
            </div>
            <div className="error-page-image col-12 col-md-3">
                <img title={"No animals were harmed in the making of this photograph"} className="rounded-12" src={emailkrabbImg} alt="Inget krabb!" style={{ width: "300px", height: "auto" }}/>
            </div>
        </div>
    </main>
    );
}